import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import { StoreProvider, ErrorFlash, Label } from '../../components';
import { updateCategory } from '../../mutations';

export class CategoryEditView extends Component {
  state = {
    name: this.props.category.name,
    errors: null,
  };

  notify = () =>
    toast.success('Category Successfully Updated!', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });

  handleName = (event) => {
    this.setState({ name: event.target.value });
  };

  // submission
  handleSubmit = (event) => {
    event.preventDefault();

    const { relay, category } = this.props;

    updateCategory(
      relay.environment,
      { id: category.id, name: this.state.name },
      {
        onCompleted: this.handleSubmitSuccess,
      }
    );
  };

  handleSubmitSuccess = (response) => {
    let { errors } = response.updateCategory;
    if (errors) {
      this.setState({ errors });
    } else {
      this.props.history.push('/categories');
      this.notify();
    }
  };

  render() {
    const { errors } = this.state;

    return (
      <div className="category-edit">
        <form className="category-form" onSubmit={this.handleSubmit}>
          <div className="form-header">
            <h2>Edit Category</h2>
            <div className="form-header-actions">
              <input
                id="saveCategory"
                className="category-edit-submit"
                type="submit"
                value="Save"
              />
            </div>
          </div>
          <div className="form-fields">
            <ErrorFlash errors={errors} />
            <div className="name-field">
              <Label attr="name" text="Name" errors={errors} />
              <input
                type="name"
                id="name"
                value={this.state.name}
                onChange={this.handleName}
                required
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const Container = withRouter(
  createFragmentContainer(CategoryEditView, {
    category: graphql`
      fragment CategoryEdit_category on Category {
        id
        name
      }
    `,
  })
);

export default class CategoryEdit extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={Container}
        query={graphql`
          query CategoryEditQuery($categoryId: ID!) {
            category(id: $categoryId) {
              ...CategoryEdit_category
            }
          }
        `}
      />
    );
  }
}
